import { AccessPointType_enum, PermissionScope_enum } from '../../../../graphql/hasura/generated';
import { getPropertyFeatureFlags } from '../../../../utils';

import type { IUseGrantableRolesArgs, IWarningFlags } from './typings';

export function getWarningFlags(args: IUseGrantableRolesArgs): IWarningFlags {
  const { permissionScope, scopedIds, scopeQueriesResult } = args;
  const { properties, units, accessPoints } = scopeQueriesResult;

  const vendorPasscodesNotEnabled = properties.some(p => !getPropertyFeatureFlags(p).VENDOR_PASSCODES);

  const controlledByPms = permissionScope === PermissionScope_enum.GLOBAL
    ? false // Prevent previous unit data from conflicting with global scope
    : units.some(u => !!u.sourceId);

  const totalAmenities = accessPoints.filter(a => a.type === AccessPointType_enum.AMENITY).length;

  const allAmenities = (
    permissionScope === PermissionScope_enum.ACCESS_POINT &&
    totalAmenities === scopedIds.length
  );

  const mixedAmenities = (
    permissionScope === PermissionScope_enum.ACCESS_POINT &&
    totalAmenities > 0 &&
    totalAmenities < scopedIds.length
  );

  const someReservationOnly = (
    !!accessPoints.length &&
    accessPoints.some(a => a.type === AccessPointType_enum.RESERVATION_ONLY)
  );

  return {
    vendorPasscodesNotEnabled,
    controlledByPms,
    allAmenities,
    mixedAmenities,
    someReservationOnly,
  };
}
